import { useStaticRandom } from '@/hooks/useStaticRandom'
import { getScore } from './getScore'
import { Center, SearchState } from '@/types/models'
import { PageType } from '@/types/models/PageType.model'

export const sortFeaturedCentersByScore = ({
  featuredCenters,
  searchState,
  locationType,
  primaryFocus,
  pageType
}: {
  featuredCenters: Center[]
  searchState?: SearchState['refinementList'] | SearchState
  locationType?: string
  primaryFocus?: string
  pageType?: PageType
}): Center[] => {
  const staticRandom = useStaticRandom()
  return featuredCenters
    .map((center) => {
      const score = getScore({
        center,
        searchState,
        staticRandom,
        locationType,
        pageType,
        primaryFocus
      })
      return { ...center, score }
    })
    .sort((a, b) => b.score - a.score)
}
